<template>
<!--  <div style="padding-top: 100px">-->
<!--    <div class="formBox">-->
<!--      <div class="title">实名认证</div>-->
<!--      <van-field v-model="name" label="姓名"  placeholder="请填写身份证号上的姓名" maxlength="8"/>-->
<!--      <van-field v-model="number" type="number" label="身份证号码" placeholder="请填写真正的身份证号"-->
<!--                 clearable maxlength="18"/>-->
<!--    </div>-->
<!--    <div class="submit" @click="confirm">立即认证</div>-->
<!--  </div>-->

  <van-overlay :show="show" @click="cancel">
    <div class="wrapper" >
      <div class="box" @click.stop>
        <div class="formBox">
          <div class="title">实名认证</div>
          <div class="note">根据店铺规定，未实名认证无法接单，为了保证您的正常使用，请同意下方协议并填写身份信息完成实名认证</div>
          <template>
            <van-field v-model="name" label="姓名"  placeholder="请填写身份证号上的姓名" maxlength="15"/>
            <van-field v-model="number" label="身份证号码" placeholder="请填写正确的身份证号"
                       clearable maxlength="18"/>
          </template>
          <div style="padding: 10px 16px">
            剩余认证次数：{{remainTryCount}}
          </div>
          <div class="agreement">
            <van-checkbox v-model="ischecked" :label-disabled="true">
              <div @click="toPath" class="text">实名认证服务协议</div>
            </van-checkbox>
          </div>
        </div>
        <div v-if="verifyMethod==='id_card_verification'" class="submit" :class="remainTryCount == 0 ? 'noneClick' : ''" @click="confirm">立即认证</div>
        <div v-if="verifyMethod==='detect_auth'" class="submit" :class="remainTryCount == 0 ? 'noneClick' : ''" @click="forward">前往认证</div>
      </div>
    </div>
  </van-overlay>
</template>


<script>


import Vue from 'vue';
import {Dialog, Field, Toast, Overlay, Checkbox, CheckboxGroup} from 'vant';
import {getDetectAuthUrl, getVerifyMethod, nameVerify} from "@/api/clerk/clerk";
import {handlePromise} from "@/libs/util";

Vue.use(Field)
    .use(Toast)
    .use(Overlay)
    .use(Checkbox)
    .use(CheckboxGroup)

export default {
  name: "certification",
  props:{
    force:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      remainTryCount: null,
      show:false,
      name: null,
      number: null,
      ischecked: false,
      verifyMethod: null,
    }
  },

  methods:{
    cancel(){
      if(!this.force){
        this.show=false;
        this.$emit('close')
        Toast('取消认证')
      }
    },
    loadData(){
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      handlePromise(getVerifyMethod(),(data)=>{
        this.verifyMethod = data.verifyMethod
        this.remainTryCount = data.remainTryCount
        this.show = true
      },(data)=>{
        Dialog.alert({
          title: '请求认证失败',
          message: data.msg
        })
        this.show = false
        this.$emit('close')
      },()=>{
        Toast.clear()
      })
    },
    forward(){
      if(!this.ischecked){
        Toast('请勾选同意认证服务协议')
        return
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      handlePromise(getDetectAuthUrl(this.name,this.number,window.location.href),(data)=>{
        window.location.href = data.authUrl.url
        this.show = false
        this.$emit('close')
      },(data)=>{
        Dialog.alert({
          title: '请求认证失败',
          message: data.msg
        })
        this.loadData()
      },()=>{
        Toast.clear()
      })
    },
    confirm(){
      if(!this.name){
        Toast('请输入姓名')
        return
      }

      if(!this.number){
        Toast('请输入身份证号码')
        return
      }

      if(!this.ischecked){
        Toast('请勾选同意认证服务协议')
        return
      }

      Toast.loading({
        mask: true,
        message: '请稍候'
      })


      nameVerify(
          this.name,
          this.number
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '认证成功',
            message: data.msg
          }).then(()=>{
            this.show = false
            this.$emit('close')
            this.$emit('success')
          })
        } else {
          Dialog.alert({
            title: '认证失败',
            message: data.msg
          })
          this.loadData()
        }
      })
    },

    toPath(){
      this.$router.push('/agreement')
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style lang="less" scoped>

.formBox{
  margin: 0 10px 20px;
  background: #fff;
  border-radius: 10px;

  .note{
    font-size: 12px;
    margin: 15px;
  }

  .title{
    font-size: 18px;
    margin: 0 16px;
    padding: 10px 0;
    position: relative;
    text-align: center;

    &::after{
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(.5);
    }
  }

  .agreement{
    padding: 10px 16px;

    .text{
      margin-left: 5px;
      color: blue;
    }
  }
}

.submit{
  width: 60%;
  margin: 0 auto;
  color: #fff;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
  background: deepskyblue;
}

.noneClick{
  pointer-events: none;
  background: #ccc;
  color: #999;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .box{
    padding: 25px 0;
    margin: 0 25px;
    background: #fff;
    border-radius: 8px;
  }
}





</style>
